import { useMutation } from '@tanstack/react-query';
import { GitlabClient } from '../httpClients/GitlabClient';
import { type GitlabProvisioningManageRequest } from '../httpClients/GitlabClient/api.schema';
import { MUTATION_KEYS } from './consts';

/**
 * v2 wizard — starts the async manage run (add/remove webhooks + bot membership
 * for the given scopes). Install is add-only (empty `remove`). Returns a
 * `manageId` to poll; outcomes surface per-scope via the manage-status query, so
 * the caller owns error rendering and this hook does not toast.
 * @returns TanStack mutation whose data holds the `manageId` to poll.
 */
export const useGitlabProvisioningManageMutation = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.GITLAB_MANAGE],
    mutationFn: (request: GitlabProvisioningManageRequest) =>
      GitlabClient.provisioningManage(request),
  });
